import { apolloClient } from '~/apollo-client';
import { VALIDATE_PRODUCT_ID } from './validate-product-id.queries';

export const validateProductId = async (
  params: ValidateProductIdParams,
): Promise<ValidateProductIdResponse> => {
  const { data } = await apolloClient.query<any, any>({
    query: VALIDATE_PRODUCT_ID,
    variables: {
      perchSfProductId: params.perchSfProductId,
      customerType: CustomerTypeMap[params.customerType as keyof typeof CustomerTypeMap],
      requireFico: params.requireFico,
      stateId: params.stateId,
    },
    fetchPolicy: 'no-cache',
  });

  const validationData = data?.validation?.perchSfProductId;

  const signupContractTemplateId = validationData?.response?.signupContractTemplateId;
  const isValid = validationData?.isValid;
  const savingsPercentage = validationData?.response?.savingsPercentage;
  const supportedCustomerTypes = validationData?.response?.supportedCustomerTypes;

  // Show error if isValid is false OR if signupContractTemplateId is null/empty
  if (!isValid || !signupContractTemplateId) {
    const errorMessage = validationData?.error?.message || 'Product validation failed';
    throw new Error(errorMessage);
  }

  return {
    signupContractTemplateId,
    isValid: true,
    message: validationData?.message,
    savingsPercentage,
    supportedCustomerTypes,
  };
};

export const CustomerTypeMap = {
  Residential: 'residential',
  Business: 'commercial',
};

export type ValidateProductIdParams = {
  perchSfProductId: string;
  customerType: string;
  requireFico: boolean;
  stateId: number;
};

export interface ValidateProductIdResponse {
  signupContractTemplateId: number;
  isValid: boolean;
  message?: string;
  savingsPercentage?: number;
  supportedCustomerTypes?: string[];
}
